export default __webpack_public_path__ + "static/media/app-rate.df526526.png";